<template>
    <div>
        <!-- 顶部导航 -->
        <NavTop></NavTop>
        <!-- 隐私设置 -->
        <div class="privacyset">
            <div class="privacyset_m row">
                <div class="privacyset_m_l column">
                    <div class="privacyset_m_l_top">隐私保护</div>
                    <div class="privacyset_m_l_main column">
                        <div :class="ziyuanbaohu == 1 ? 'privacyset_m_l_main_m2' : 'privacyset_m_l_main_m'"
                            @click="yinsibaohu(1)">屏蔽公司</div>
                        <div :class="ziyuanbaohu == 2 ? 'privacyset_m_l_main_m2' : 'privacyset_m_l_main_m'"
                            @click="yinsibaohu(2)">查看权限</div>
                    </div>
                </div>
                <div class="privacyset_m_r column" v-if="ziyuanbaohu == 1">
                    <div class="privacyset_m_r_top">屏蔽公司</div>
                    <div class="privacyset_m_r_main column">
                        <div class="privacyset_m_r_main_tishi">
                            添加屏蔽公司后，你和这些公司的Boss，都不会被相互推荐，你的查看行为也不会告知对方
                        </div>
                        <div class="privacyset_m_r_main_sousuo row">
                            <div class="privacyset_m_r_main_sousuo_l row">
                                <el-autocomplete v-model="state" :fetch-suggestions="querySearchAsync"
                                    placeholder="搜索公司全称、简称、邮箱后缀" prefix-icon="el-icon-search"
                                    class="privacyset_m_r_main_sousuo_l_l" @select="handleSelect"></el-autocomplete>
                                <div class="privacyset_m_r_main_sousuo_l_pingbi">添加屏蔽</div>
                            </div>

                            <div class="privacyset_m_r_main_sousuo_r row">
                                清空所有屏蔽
                            </div>
                        </div>
                        <div class="privacyset_m_r_main_pbtitle">
                            简历自动屏蔽 <span>1</span> 家公司
                        </div>
                        <div class="privacyset_m_r_main_pblist column">
                            <div class="privacyset_m_r_main_pblist_m row" v-for="(item, index) in 2" :key="index">
                                <div class="privacyset_m_r_main_pblist_m_l">公司名称公司名称公司名称公司名称公司名称公司名称公司名称公司名称公司名称公司名称</div>
                                <div class="privacyset_m_r_main_pblist_m_r">解除屏蔽</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="privacyset_m_r column" v-if="ziyuanbaohu == 2">
                    <div class="privacyset_m_r_top">查看权限</div>
                    <div class="privacyset_m_r_main column">
                        <div class="privacyset_m_r_main_list row">
                            <div class="privacyset_m_r_main_list_l">对猎头顾问隐藏</div>
                            <div class="privacyset_m_r_main_list_r">
                                <el-switch v-model="duilietouguwenyincang" active-color="#00b277" inactive-color="#e0e0e0">
                                </el-switch>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 底部 -->
        <Footer></Footer>
    </div>
</template>

<script>
import NavTop from '@/components/NavTop.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'LaPrivacySet',
    components: { NavTop, Footer },
    data() {
        return {
            ziyuanbaohu: 1,
            restaurants: [],
            state: '',
            timeout: null,
            duilietouguwenyincang: false,
        }
    },
    activated() {

    },
    methods: {
        yinsibaohu(val) {
            this.ziyuanbaohu = val;
        },
        loadAll() {
            return [
                { "value": "三全鲜食（北新泾店）", "address": "长宁区新渔路144号" },
                { "value": "Hot honey 首尔炸鸡（仙霞路）", "address": "上海市长宁区淞虹路661号" },
                { "value": "新旺角茶餐厅", "address": "上海市普陀区真北路988号创邑金沙谷6号楼113" },
                { "value": "泷千家(天山西路店)", "address": "天山西路438号" },
                { "value": "胖仙女纸杯蛋糕（上海凌空店）", "address": "上海市长宁区金钟路968号1幢18号楼一层商铺18-101" },
                { "value": "贡茶", "address": "上海市长宁区金钟路633号" },
                { "value": "豪大大香鸡排超级奶爸", "address": "上海市嘉定区曹安公路曹安路1685号" },
                { "value": "茶芝兰（奶茶，手抓饼）", "address": "上海市普陀区同普路1435号" },
                { "value": "十二泷町", "address": "上海市北翟路1444弄81号B幢-107" },
                { "value": "星移浓缩咖啡", "address": "上海市嘉定区新郁路817号" },
                { "value": "阿姨奶茶/豪大大", "address": "嘉定区曹安路1611号" },
                { "value": "新麦甜四季甜品炸鸡", "address": "嘉定区曹安公路2383弄55号" },
                { "value": "Monica摩托主题咖啡店", "address": "嘉定区江桥镇曹安公路2409号1F，2383弄62号1F" },
                { "value": "浮生若茶（凌空soho店）", "address": "上海长宁区金钟路968号9号楼地下一层" },
                { "value": "NONO JUICE  鲜榨果汁", "address": "上海市长宁区天山西路119号" },
                { "value": "CoCo都可(北新泾店）", "address": "上海市长宁区仙霞西路" },
                { "value": "快乐柠檬（神州智慧店）", "address": "上海市长宁区天山西路567号1层R117号店铺" },
                { "value": "Merci Paul cafe", "address": "上海市普陀区光复西路丹巴路28弄6号楼819" },
                { "value": "猫山王（西郊百联店）", "address": "上海市长宁区仙霞西路88号第一层G05-F01-1-306" },
                { "value": "枪会山", "address": "上海市普陀区棕榈路" },
                { "value": "纵食", "address": "元丰天山花园(东门) 双流路267号" },
                { "value": "钱记", "address": "上海市长宁区天山西路" },
                { "value": "壹杯加", "address": "上海市长宁区通协路" },
                { "value": "唦哇嘀咖", "address": "上海市长宁区新泾镇金钟路999号2幢（B幢）第01层第1-02A单元" },
                { "value": "爱茜茜里(西郊百联)", "address": "长宁区仙霞西路88号1305室" },
                { "value": "爱茜茜里(近铁广场)", "address": "上海市普陀区真北路818号近铁城市广场北区地下二楼N-B2-O2-C商铺" },
                { "value": "鲜果榨汁（金沙江路和美广店）", "address": "普陀区金沙江路2239号金沙和美广场B1-10-6" },
                { "value": "开心丽果（缤谷店）", "address": "上海市长宁区威宁路天山路341号" },
                { "value": "超级鸡车（丰庄路店）", "address": "上海市嘉定区丰庄路240号" },
                { "value": "妙生活果园（北新泾店）", "address": "长宁区新渔路144号" },
                { "value": "香宜度麻辣香锅", "address": "长宁区淞虹路148号" },
                { "value": "凡仔汉堡（老真北路店）", "address": "上海市普陀区老真北路160号" },
                { "value": "港式小铺", "address": "上海市长宁区金钟路968号15楼15-105室" },
                { "value": "蜀香源麻辣香锅（剑河路店）", "address": "剑河路443-1" },
                { "value": "北京饺子馆", "address": "长宁区北新泾街道天山西路490-1号" },
                { "value": "饭典*新简餐（凌空SOHO店）", "address": "上海市长宁区金钟路968号9号楼地下一层9-83室" },
                { "value": "焦耳·川式快餐（金钟路店）", "address": "上海市金钟路633号地下一层甲部" },
                { "value": "动力鸡车", "address": "长宁区仙霞西路299弄3号101B" },
                { "value": "浏阳蒸菜", "address": "天山西路430号" },
                { "value": "四海游龙（天山西路店）", "address": "上海市长宁区天山西路" },
                { "value": "樱花食堂（凌空店）", "address": "上海市长宁区金钟路968号15楼15-105室" },
                { "value": "壹分米客家传统调制米粉(天山店)", "address": "天山西路428号" },
                { "value": "福荣祥烧腊（平溪路店）", "address": "上海市长宁区协和路福泉路255弄57-73号" },
                { "value": "速记黄焖鸡米饭", "address": "上海市长宁区北新泾街道金钟路180号1层01号摊位" },
                { "value": "红辣椒麻辣烫", "address": "上海市长宁区天山西路492号" },
                { "value": "(小杨生煎)西郊百联餐厅", "address": "长宁区仙霞西路88号百联2楼" },
                { "value": "阳阳麻辣烫", "address": "天山西路389号" },
                { "value": "南拳妈妈龙虾盖浇饭", "address": "普陀区金沙江路1699号鑫乐惠美食广场A13" }
            ];
        },
        querySearchAsync(queryString, cb) {
            var restaurants = this.restaurants;
            var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;

            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                cb(results);
            }, 3000 * Math.random());
        },
        createStateFilter(queryString) {
            return (state) => {
                return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        handleSelect(item) {
            console.log(item);
        }
    },
    mounted() {
        this.restaurants = this.loadAll();
    }

}
</script>
<style scoped>
.privacyset {
    max-width: 1200px;
    min-height: 700px;
    margin: 20px auto -20px;
}

.privacyset_m {
    min-height: 700px;
    justify-content: space-between;
}

.privacyset_m_l {
    width: 220px;
    background: #fff;
    text-align: center;
    border-radius: 10px;
}

.privacyset_m_l_top {
    background: linear-gradient(90deg, #f5fcfc, #fcfbfa);
    border-radius: 12px 12px 0 0;
    font-size: 20px;
    font-weight: 600;
    padding: 30px 0;
    color: #222;
    padding-left: 40px;
    text-align: left;
}

.privacyset_m_l_main {}

.privacyset_m_l_main_m {
    height: 62px;
    width: 220px;
    line-height: 62px;
    font-weight: 500;
    color: #666;
    cursor: pointer;
    font-size: 16px;
    margin: 0;
    padding-left: 40px;
    text-align: left;
    transition: all .1s;
}

.privacyset_m_l_main_m2 {
    background-color: #00b2771a;
    font-weight: 600;
    color: #222;
    height: 62px;
    line-height: 62px;
    cursor: pointer;
    font-size: 16px;
    margin: 0;
    padding-left: 40px;
    text-align: left;
    transition: all .1s;
    border-left: 4px solid #00b277;
}


.privacyset_m_r {
    background-color: #fff;
    min-height: 100%;
    border-radius: 10px;
    flex: 1;
    margin-left: 5px;
    padding: 0 60px;
}

.privacyset_m_r_top {
    padding-top: 30px;
    padding-bottom: 24px;
    font-size: 20px;
    font-weight: 600;
    color: #222;
    line-height: 28px;
    border-bottom: 1px solid #e6e6e6;
}

.privacyset_m_r_main {
    padding: 20px 0;
}

.privacyset_m_r_main_tishi {
    height: 20px;
    line-height: 20px;
    font-size: 14px;
}

.privacyset_m_r_main_sousuo {
    padding: 20px 0px 0px;
    justify-content: space-between;
    margin-bottom: 24px;
}

.privacyset_m_r_main_sousuo_l {
    width: 60%;
}

.privacyset_m_r_main_sousuo_l_l {
    flex: 1;
}

.privacyset_m_r_main_sousuo_l_pingbi {
    width: 100px;
    color: #fff;
    background: #00b277;
    font-size: 16px;
    padding: 10px 0;
    border-radius: 8px;
    text-align: center;
    margin-left: 10px;
    cursor: pointer;
}

.privacyset_m_r_main_sousuo_r {
    display: inline-block;
    line-height: 36px;
    text-align: center;
    width: 108px;
    height: 36px;
    border-radius: 6px;
    cursor: pointer;
    border: 1px solid rgb(255, 255, 255);
    color: #00b277;
    background: #00b2771a;
}

.privacyset_m_r_main_sousuo_r:hover {
    background: #00b277;
    color: rgb(255, 255, 255);
}

.privacyset_m_r_main_pbtitle {
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: 600;
    color: #222;
    line-height: 25px;
}

.privacyset_m_r_main_pbtitle>span {
    font-size: 18px;
    font-weight: 600;
    color: #00b277;
    line-height: 25px;
}

.privacyset_m_r_main_pblist {
    width: 840px;
    min-height: 260px;
    max-height: 500px;
    background: #fff;
    border-radius: 12px;
    border: 1px solid #f4f4f4;
    padding: 10px;
    margin: auto auto 10px;
    overflow: auto;
}

.privacyset_m_r_main_pblist::-webkit-scrollbar {
    width: 5px;
}

.privacyset_m_r_main_pblist::-webkit-scrollbar-track {
    background: #fff;
}

.privacyset_m_r_main_pblist::-webkit-scrollbar-thumb {
    background: #dddddd;
    border-radius: 5px;
}

.privacyset_m_r_main_pblist::-webkit-scrollbar-thumb:hover {
    background: #fff;
}

.privacyset_m_r_main_pblist_m {
    height: 40px;
    border-radius: 8px;
    padding-left: 12px;
    padding-right: 6px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    line-height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
}

.privacyset_m_r_main_pblist_m:hover {
    background: #fff;
    box-shadow: 0 4px 16px 0 hsla(0, 0%, 60%, .2);
}

.privacyset_m_r_main_pblist_m:hover .privacyset_m_r_main_pblist_m_r {
    display: block;
}


.privacyset_m_r_main_pblist_m_l {
    font-size: 14px;
    font-weight: 400;
    color: #333;
    line-height: 40px;
}

.privacyset_m_r_main_pblist_m_r {
    display: none;
    width: 96px;
    height: 28px;
    border-radius: 6px;
    border: 1px solid #fff;
    color: #00b277;
    background: #00b2771a;
    text-align: center;
    line-height: 28px;
}

.privacyset_m_r_main_pblist_m_r:hover {
    background: #00b277;
    color: #fff;
}

.privacyset_m_r_main_list {}

.privacyset_m_r_main_list_l {
    width: 280px;
    font-weight: 400;
    line-height: 20px;
    height: 20px;
    color: #333;
}

.privacyset_m_r_main_list_r {
    width: 35px;
    height: 20px;
}
</style>
